import React, { useContext, useState, useEffect, useRef } from 'react';
import Papa from 'papaparse';
import '../ProductList.css';
import { useNavigate } from 'react-router-dom';
import Slider from './Silder';
import { CartContext } from "../CartContext";
import VideoPopup from './VideoPopup';

const KidBlanks = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [color, setColor] = useState('');
  const [percentage, setPercentage] = useState('');
  const [selectedTags, setSelectedTags] = useState({
    Infant: false,
    Toddler: false,
    Youth: false,
    "Sweatshirts": false,
    'Full Zip': false,
    Pants: false,
    Shorts: false,
    'T-Shirts': false,
    Caps: false,
    Activewear: false,
    Outerwear: false,
    'Long Sleeve': false,
    'Polos': false
  });

  const [sliderValue, setSliderValue] = useState(10.8);
  const itemsPerPage = 12;
  const navigate = useNavigate();
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) videoRef.current.play();
  }, []);
  const vendorsToExclude = [
    "Brooks Brothers", "New Era", "Outdoor Research", "The North Face",
    "Carhartt", "Nike", "Stanley/Stella", "Tommy Bahama", "Cotopaxi",
    "OGIO", "tentree", "Travis Mathew", "Eddie Bauer"
  ];



  const loadCSV = async () => {
    const csvUrl = './kidsListMenu.csv';
    try {
      const response = await fetch(csvUrl);
      if (!response.ok) throw new Error('Failed to load CSV file');
      const csvData = await response.text();

      Papa.parse(csvData, {
        complete: (result) => {
          const today = new Date();
          const data = result.data;

          const parsedProducts = data.slice(1)
            .filter((item) => !vendorsToExclude.includes(item[4]))
            .map((item) => {
              const parseDate = (dateStr) => {
                if (!dateStr) return null;
                const [month, day, year] = dateStr.split('/').map(Number);
                return new Date(year, month - 1, day);
              };

              const price = parseFloat(item[1]) || 0;
              const salePrice = parseFloat(item[52]) || 0;
              const endSaleDate = parseDate(item[52]);
              const isOnSale = endSaleDate && endSaleDate >= today;

              let discountPercentage = 0;
              if (price > 0 && salePrice > 0 && salePrice < price) {
                discountPercentage = Math.round(((price - salePrice) / price) * 100);
              }

              return {
                Handle: item[29],
                ColorVal: item[33],
                Size: item[14],
                DefaultImageSrc: item[2],
                HoverImageSrc: item[23] || item[24] || item[25],
                Price: price,
                SalePrice: salePrice,
                DiscountPercentage: discountPercentage,
                Description: item[3],
                Style: item[13],
                EndSale: endSaleDate,
                Tags: item[6]?.split(',').map(tag => tag.trim()) || [],
                isOnSale,
              };
            });

          setProducts(parsedProducts);
          setFilteredProducts(parsedProducts);
          setLoading(false);
        },
        header: false,
        skipEmptyLines: true,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    loadCSV();
  }, []);

  const handleAddToCart = (product) => {
    navigate(`/product/${product.Style}`);
  };

  useEffect(() => {
    let updatedProducts = [...products];

    if (color) {
      updatedProducts = updatedProducts.filter(product =>
        product.ColorVal.split(',').some(c => c.trim().toLowerCase().includes(color.toLowerCase()))
      );
    }

    const selectedTagKeys = Object.keys(selectedTags).filter(tag => selectedTags[tag]);
    if (selectedTagKeys.length > 0) {
      updatedProducts = updatedProducts.filter(product =>
        selectedTagKeys.some(tag => product.Tags.includes(tag))
      );
    }

    if (searchTerm) {
      updatedProducts = updatedProducts.filter(product =>
        product.Handle.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.Description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    const maxPrice = Math.max(...products.map(p => p.Price));
    const minPrice = Math.min(...products.map(p => p.Price));
    const targetPrice = minPrice + ((maxPrice - minPrice) * sliderValue) / 100;

    updatedProducts.sort((a, b) => {
      const diffA = Math.abs(a.Price - targetPrice);
      const diffB = Math.abs(b.Price - targetPrice);
      return diffA - diffB || a.Price - b.Price;
    });

    setFilteredProducts(updatedProducts);
  }, [products, selectedTags, searchTerm, sliderValue, color]);

  const indexOfLastProduct = currentPage * itemsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleTagChange = (e) => {
    setSelectedTags((prevTags) => ({
      ...prevTags,
      [e.target.name]: e.target.checked,
    }));
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  if (loading) return <span className="loader"></span>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <>
      <div className="product-list-container">
        <VideoPopup />
        <div className="sidebar">
          <div className="sidebar-content">
            <div className="slider-container" style={{ marginLeft: -5, width: "100%" }}>
              <Slider width={"100%"} height={130} />
            </div>
            <div className="search-box">
              <h6 style={{ marginTop: -15, marginLeft: 5 }}>Categories</h6>
              <input
                type="text"
                value={searchTerm}
                style={{ fontSize: 8 }}
                onChange={handleSearchChange}
                placeholder="Search by name..."
              />
            </div>
            <div className="checkbox-filters">
              {Object.keys(selectedTags).map(tag => (
                <label key={tag}>
                  <input
                    type="checkbox"
                    name={tag}
                    checked={selectedTags[tag]}
                    onChange={handleTagChange}
                  />
                  {tag}
                </label>
              ))}
            </div>
          </div>
          <hr style={{ marginTop: -20, marginBottom: 0 }} />
          <div className="slider-container" style={{ textAlign: "center" }}>
            <label htmlFor="price-slider">Sort by Price</label>
            <input
              type="range"
              id="price-slider"
              min="0"
              max="100"
              value={sliderValue}
              onChange={(e) => setSliderValue(parseInt(e.target.value, 10))}
            />
            <div className="labels" style={{ marginBottom: -15 }}>
              <span className="low">$3</span>
              <span className="high">$55</span>
            </div>
          </div>
          <hr style={{ marginTop: -10, marginBottom: 0 }} />
          {/* <div className="email" style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
            boxSizing: "border-box"
          }}>
            <input
              ref={inputRef}
              style={{
                fontSize: "9px",
                width: "100%",
                maxWidth: "300px",
                height: "28px",
                padding: "2px",
                marginBottom: "-5px",
                borderRadius: "15px",
                border: "2px, solid, white"
              }}
              type="email"
              placeholder='Get notified on our sales'
            />

            <button onClick={subs} style={{ backgroundColor: "black", color: "white", borderRadius: 15, fontWeight: "bold", marginBottom: 10, height: 30, width: "100%", maxWidth: 200, marginTop: 10 }}>SUBSCRIBE</button>

          </div> */}
          {/* <div style={{ textAlign: "center", maxWidth:190}}>
            <label style={{marginBottom:10}}>Search by Color</label>
            <input placeholder="Saerch by color" style={{border:"none",fontSize:14, height:40, textAlign:"center",width:"100%", borderRadius:5}} type="text" OnChange={(e) => setColor(e.target.value)}></input>
          </div> */}
        </div>

        {/* Product Grid */}
        <div className="product-grid">
          {currentProducts.length > 0 ? (
            currentProducts.map((product, index) => (

              <div key={index} className="product-card" onClick={() => handleAddToCart(product)}>
                <div className="image-container">
                  {product.isOnSale && (
                    <div className="sale-badge">{product.DiscountPercentage}% OFF</div>
                  )}
                  <a href={`/product/${product.Style}`} style={{ textDecoration: "none", color: "black" }}>
                    <img
                      src={product.DefaultImageSrc}
                      alt={product.Handle}
                      className="product-image default-image"
                    />
                    <img
                      src={product.HoverImageSrc}
                      alt={`${product.Handle} Hover`}
                      className="product-image hover-image"
                    />
                  </a>
                </div>
                <div className="product-details">
                  <h3 className="product-handle">{product.Handle}</h3>
                  {/* <p className="product-price">Price: From ${product.Price}</p> */}
                  <div className="product-price">
                    Price: From{" "}
                    {product.SalePrice > 0 && product.SalePrice < product.Price ? (
                      <>
                        <p className="product-price" style={{ textDecoration: 'line-through', color: 'grey' }}>${product.Price}</p>{" "}
                        <p className="text-red-600 font-bold">${product.SalePrice}</p>
                      </>
                    ) : (
                      <> ${product.Price}</>
                    )}
                  </div>
                </div>
                <div className="product-details2">
                  {product.Size}
                </div>
              </div>

            ))
          ) : (
            <p>No products available.</p>
          )}
        </div>
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <img src="/images/assets/arrowFirs.png" style={{ maxWidth: 35, marginRight: -35 }} alt="First" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img src="/right-arrow.png" style={{ maxWidth: 35 }} alt="Next" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <img src="/images/assets/arrowLast.png" style={{ maxWidth: 35, marginLeft: -35 }} alt="Last" />
        </button>
      </div>
    </>
  );
};

export default KidBlanks;
